// NATIVE
import * as React from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import VerifiedIcon from '@mui/icons-material/Verified';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


// CUSTOM 
import { eachWordUpper, userHasPermissionFormated } from '../../commons/utils';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, FormGroup } from '@mui/material';






export const  DetalleModulosPermisos = (props:any) => {

  // NAVIGATE 
  const navigate = useNavigate();


  // REDUX 
  const { customer }:any  = useSelector( (state:any) => state.customer );
  const { permissions }:any  = useSelector( (state:any) => state.permissions );




  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [pemisssionsListFormated, setPermissionsListFormated] = React.useState([]);



  React.useEffect(() => {


    if (customer) {

        formatPermissionsData(permissions, customer).then( function(result) {
              setPermissionsListFormated(result);
        });
    }

     
  }, [customer]); 



  React.useEffect(() => {
    
      if ( !customer || Object.keys(customer).length == 0 ) {
           navigate("/manager/clientes");
      }

  }, [customer]);
  



  const formatPermissionsData = async( permissions:any, customer:any ) => {

        return await userHasPermissionFormated(permissions, customer);

  }

 
  
  
  
 
  return (


    <div>


            {

              pemisssionsListFormated.map((item:any, index:any) => ( 

                

                <>
                  {
                    
                    item.childrens.length > 0 
                    ?
                      
    
                      <Card   sx={{  marginTop: 10, borderTop: 2, borderColor: '#192a56'  }} key={index}>
                        <Card >
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                              <CardContent sx={{ flex: '1 0 auto' }}>
                                <Typography component="div" variant="h5">
                                  { eachWordUpper(item.text) } <VerifiedIcon/>
                                  {/* { JSON.stringify(item) } */}
                                </Typography>
                                <Typography
                                  variant="subtitle1"
                                  component="div"
                                  sx={{ color: 'text.secondary' }}
                                >
                                  { eachWordUpper('Sub modulos y permisos') }
                                </Typography>
                              </CardContent>
                            
                              <div > 

                                {/* PERMISOS MODULO PADRE  */}
                                <>
                                    <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                        <div style={{ display: 'flex',  lineHeight: 0 }}>
                                            <FormGroup>
                                              <FormControlLabel  control={<Checkbox  checked={ item.isChecked }  name={`mod_${item.permission_slug}`} />} label={'Modulo habilitado'} />
                                            </FormGroup>
                                        </div>
                                    </Box>
                                </>
                                {/* FIN PERMISOS MODULO PADRE  */}

                                
                                  {item.childrens.map((element:any, indexf:any) => ( 

                                    <Accordion expanded={true} >
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={{ color: 'text.secondary' }}>{ eachWordUpper('Habilitar opciones') }</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>

                                      
                                        <Typography component="div" variant="h5">
                                            {/* ELEMENT CHILDREN  */}
                                            { eachWordUpper(element.text) } 
                                            <Typography
                                                variant="subtitle1"
                                                component="div"
                                                sx={{ color: 'text.secondary' }}>
                                                { eachWordUpper(item.text) }
                                              </Typography>
                                              <Typography
                                                variant="subtitle1"
                                                component="div"
                                                sx={{ color: 'text.secondary' }}
                                              >
                                            </Typography>

                                          </Typography>

                                      <Box sx={{  display: 'flex', flexDirection: 'row', marginTop: 2 }}>
                                        <CardContent sx={{ flex: '1 0 auto' }}>
                                          
                                          
                                        </CardContent>
                                        <Box sx={{  display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                  <FormGroup>
                                                    <FormControlLabel control={<Checkbox checked={ element.isChecked } inputProps={{ 'aria-label': 'controlled' }}    name={`mod_${element.slug}`} />}  label={'Modulo Habilitado'} />
                                                  </FormGroup>
                                              </div>
                                        </Box>
                                        
                                        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                        
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                              
                                               <FormGroup>
                                               
                                                  <FormControlLabel control={<Checkbox checked={ element.actions ? element.actions.includes('view') : false }   name={`ver_${element.slug}`} />}  label={'Ver'} />
                                                </FormGroup>
                                              </div>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox checked={ element.actions ? element.actions.includes('create') : false }    name={`crear_${element.slug}`} />}  label={'Crear'} />
                                                </FormGroup>
                                              </div>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox checked={ element.actions ? element.actions.includes('edit') : false }    name={`editar_${element.slug}`} />}  label={'Editar'} />
                                                </FormGroup>
                                              </div>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox checked={ element.actions ? element.actions.includes('delete') : false }    name={`eliminar_${element.slug}`} />}  label={'Eliminar'} />
                                                </FormGroup>
                                              </div>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox checked={ element.actions ? element.actions.includes('restore') : false }    name={`restore_${element.slug}`} />}  label={'Restaurar'} />
                                                </FormGroup>
                                              </div>
                                        </Box>
                                      </Box>
                                  
                                      </AccordionDetails>
                                    </Accordion>
                                  ))}


                                
                                
                              </div>
                          </Box>
                        </Card>
                      </Card>
                    :
                    ''
                  }
                   
   
                   
                </>
                
              ))

            }

    </div>
    
  );
}